import { render, staticRenderFns } from "./ListShukasakiSoko.vue?vue&type=template&id=49ed3af2&"
import script from "./ListShukasakiSoko.vue?vue&type=script&lang=ts&"
export * from "./ListShukasakiSoko.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports